module.exports = __webpack_public_path__ + "static/fonts/NotoSans-Bold.e6ee53a.otf";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NotoSans-Bold.otf
// module id = 2VJx
// module chunks = 0